/**
 * Solvia Menu Drawer (left slide-in, PC/SP common)
 * Triggered by any element with [data-solvia-menu-trigger].
 * ESC / scrim click / [data-solvia-menu-close] closes.
 * Sub-menus are native <details>; CSS swaps + / — via [open].
 */
class SolviaMenuDrawer extends HTMLElement {
  /** @type {HTMLElement | null} */
  panel = null;
  /** @type {boolean} */
  isOpen = false;
  /** @type {NodeListOf<HTMLElement>} */
  triggers = /** @type {NodeListOf<HTMLElement>} */ (document.querySelectorAll('[data-solvia-menu-trigger]'));
  /** @type {(event: KeyboardEvent) => void} */
  handleKeyDown = () => {};
  /** @type {() => void} */
  handleTriggerClick = () => {};

  connectedCallback() {
    this.panel = /** @type {HTMLElement | null} */ (this.querySelector('.solvia-menu-drawer__panel'));
    this.triggers = /** @type {NodeListOf<HTMLElement>} */ (document.querySelectorAll('[data-solvia-menu-trigger]'));

    this.handleTriggerClick = () => this.toggle();
    this.triggers.forEach((t) => t.addEventListener('click', this.handleTriggerClick));

    this.querySelectorAll('[data-solvia-menu-close]').forEach((el) => {
      el.addEventListener('click', () => this.close());
    });

    this.handleKeyDown = (event) => {
      if (event.key === 'Escape' && this.isOpen) this.close();
    };
    document.addEventListener('keydown', this.handleKeyDown);
  }

  disconnectedCallback() {
    document.removeEventListener('keydown', this.handleKeyDown);
    this.triggers.forEach((t) => t.removeEventListener('click', this.handleTriggerClick));
  }

  toggle() {
    if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.isOpen = true;
    this.setAttribute('open', '');
    this.setAttribute('aria-hidden', 'false');

    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.body.style.paddingRight = `${scrollbarWidth}px`;
    document.body.style.overflow = 'hidden';

    this.triggers.forEach((t) => {
      t.setAttribute('aria-expanded', 'true');
      t.classList.add('is-open');
    });

    if (this.panel) {
      this.panel.focus({ preventScroll: true });
    }
  }

  close() {
    this.isOpen = false;
    this.removeAttribute('open');
    this.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';

    this.triggers.forEach((t) => {
      t.setAttribute('aria-expanded', 'false');
      t.classList.remove('is-open');
    });
  }
}

if (!customElements.get('solvia-menu-drawer')) {
  customElements.define('solvia-menu-drawer', SolviaMenuDrawer);
}
